const router = [
  {
    path: '/project-appoint-home',
    name: 'ProjectAppointHome',
    component: () => import('../views/ProjectAppoint/ProjectAppointHome.vue')
  },
  {
    path: '/project-appoint-index',
    name: 'ProjectAppointIndex',
    component: () => import('../views/ProjectAppoint/ProjectAppointIndex.vue')
  },
  {
    path: '/project-appoint-detail',
    name: 'ProjectAppointDetail',
    component: () => import('../views/ProjectAppoint/ProjectAppointDetail.vue'),
    redirect: 'project-appoint-detail/ShowProtocol',
    children: [
      {
        path: 'ShowProtocol', //项目进度查询和办理主页
        name: 'ShowProtocol',
        component: () => import('../views/ProjectAppoint/ShowProtocol.vue')
      },
      {
        path: 'CommonFormFinal', //项目信息
        name: 'CommonFormFinal',
        component: () => import('../views/ProjectAppoint/CommonFormFinal.vue')
      },
      {
        path: 'CascaderSelect', //测绘服务事项
        name: 'CascaderSelect',
        component: () => import('../views/ProjectAppoint/CascaderSelect.vue')
      },
      {
        path: 'ProjectAppointOrgan', //选择机构
        name: 'ProjectAppointOrgan',
        component: () => import('../views/ProjectAppoint/ProjectAppointOrgan.vue')
      },
      {
        path: 'FileTable', //合同备案
        name: 'FileTable',
        component: () => import('../views/ProjectAppoint/FileTable.vue')
      },
    ]
  },
  {
    path: '/project-appoint-info-confirm', // 信息确认
    name: 'projectAppointInfoConfirm',
    component: () =>
      import('../views/ProjectAppoint/ProjectAppointInfoConfirm.vue')
  },
  // {
  //   path: '/project-appoint-apply-detail', // 申请详情
  //   name: 'projectAppointApplyDetail',
  //   component: () =>
  //     import('../views/ProjectAppoint/ProjectAppointApplyDetail.vue')
  // },
]

export default router
